<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h1>Chart</h1>

				<div class="card">
					<div class="card-body py-0">
						<div class="header mb-0">
							<div class="header-body">
								<div class="row align-items-end">
									<div class="col">
										<h2 class="mb-2">Daily Performance</h2>
										<small class="text-muted">updated XXX</small>
									</div>
									<div class="col-auto">
										Selected Metric / Cost Per Selected Metric / Spend
									</div><!--/.col-auto-->
								</div><!-- / .row -->
							</div><!--/.header-body-->

							<div class="header-footer">

								<!-- Chart -->
								<div class="chart">
									<div v-if="!loaded">
										Fetching data
									</div>
									<canvas id="performanceChart" class="chart-canvas"></canvas>
								</div>

							</div><!--/.header-footer-->
						</div><!--/.header-->

					</div><!--/.card-body-->
				</div><!--/.card-->

			</div>
		</div><!--/.row-->
	</div><!--/.container-fluid-->
</template>

<script>
// import { Bar } from 'vue-chartjs'
// import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

// import '../../dashkit/chart.js';

// ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {

	props: ['project'],

	components: { },

	data: () => ({
		loaded: false,
		chartData: null
	}),

	async mounted () {

		this.loaded = false;

		const ctx = document.getElementById('performanceChart');
		const performanceChart = new Chart(ctx, {
			type: "line",
			data: {
				labels: ["Mercury", "Venus", "Earth", "Mars", "Jupiter", "Saturn", "Uranus", "Neptune"],
				datasets: [
					{
						label: "Number of Moons",
						data: [0, 0, 1, 2, 79, 82, 27, 14],
						backgroundColor: "rgba(54,73,93,.5)",
						borderColor: "#36495d",
						borderWidth: 3
					},
					{
						label: "Planetary Mass (relative to the Sun x 10^-6)",
						data: [0.166, 2.081, 3.003, 0.323, 954.792, 285.886, 43.662, 51.514],
						backgroundColor: "rgba(71, 183,132,.5)",
						borderColor: "#47b784",
						borderWidth: 3
					}
				]
			},
			options: {
				responsive: true,
				lineTension: 1,
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								padding: 25
							}
						}
					]
				}
			}
		});

		// try {
		// 	// const { userlist } = await fetch('/api/userlist');
		// 	// this.chartdata = userlist;
		// 	// this.loaded = true;
		// } catch (e) {
		// 	console.error(e);
		// }
	}
}
</script>
